import { Injectable } from '@angular/core'


import { Observable } from "rxjs";
import { AngularFireDatabase, FirebaseListObservable } from "angularfire2/database-deprecated";
import { RouterModule, Router } from '@angular/router';
import { FirebaseApp } from 'angularfire2';

@Injectable()
export class NewsService {
    
    private image;
    constructor(private af: AngularFireDatabase, private firebaseApp: FirebaseApp,private router:Router) {
        
    }
    getNewsPomotions() {
        return this.af.list('news');
    }
    getNewsShows() {
        return this.af.list('news').map((array) => array.reverse()) as FirebaseListObservable<any[]>;
    }

    getNewsPomotion() {
        return this.af.list('news');
    }
    getNewsShow() {
        return this.af.list('news').map((array) => array.reverse()) as FirebaseListObservable<any[]>;
    }
    getNewsPromotionId(id) {
        let dataSent;
        let item = this.af.list('news');
        item.subscribe((snap) => {
            for(var i=0;i<snap.length;i++){
                if(snap[i].id == id){
                    dataSent = snap[i];
                }
            }
        })
        return dataSent;
    }
    getNewsShowId(id) {
        let dataSent;
        let item = this.af.list('news').map((array) => array.reverse()) as FirebaseListObservable<any[]>;
        item.subscribe((snap) => {
            dataSent = snap[id]
        })
        return dataSent
    }
    getAdvertise() {
        return this.af.list('advertisement')
    }
    getadverId(id) {
        let dataSent;
        let item = this.af.list('advertisement')
        item.subscribe((snap) => {
            dataSent = snap[id]
        })
        return dataSent
    }
    // Function Add News
    addNew(data) {
        let addNews = this.af.list('/news')
        // get Data link image 
        addNews.push(data)
        alert("เพิ่มข่าวสารเสร็จสิ้น")
        location.reload();
    }
    // Function Remove News
    removeNews(id) {
        let itemRemove;
        let removeNews = this.af.list('/news');
        removeNews.subscribe((snap) => {
            for(var i=0;i<snap.length;i++){
                if(snap[i].id == id){
                    itemRemove = snap[i]
                }
            }
            //itemRemove = snap[id]
        })
        let rmv = this.af.list('/news');
        rmv.remove(itemRemove)
        alert("ลบเสร็จสิ้น")
    }
    removeAdverise(id) {
        let itemRemove;
        let removeNews = this.af.list('/advertisement');
        removeNews.subscribe((snap) => {
            itemRemove = snap[id]
        })
        let rmv = this.af.list('/advertisement');
        rmv.remove(itemRemove)
        alert("ลบเสร็จสิ้น")
    }
    addAdvertisement(dataItem) {
        let addNews = this.af.list('/advertisement')
        // get Data link image 
        addNews.push(dataItem).then(res => {
            alert("เพิ่มโฆษณาเสร็จสิ้น")
            location.reload();
        })
    }
    // =========================
    // Function Update News
    // =========================
    
    updateNews(dataItem, idd) {
        let itemTmp;
        let updateData = this.af.list('/news')
        updateData.subscribe((snap) => {
            for(var i = 0;i<snap.length;i++){
                if(snap[i].id == idd){
                    itemTmp = snap[i]
                    console.log(itemTmp)
                }
            }  
        })
        updateData.update(itemTmp, dataItem).then((success) => {
            alert("แก้ไขเสร็จสิ้น")
            //location.reload();
            this.router.navigate(['/admin/news']);
        })
    }

    // =============================
    // Function Update AdvertiseMent
    // =============================
    updateAdvertise(dataItem, idd) {
        let itemTmp;
        let updateData = this.af.list('/advertisement')
        updateData.subscribe((snap) => {
            itemTmp = snap[idd]
        })
        updateData.update(itemTmp, dataItem).then((success) => {
            alert("แก้ไขเสร็จสิ้น")
        })
    }
}


// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/services/newsService.ts